export const setKeyValue = (key: string, value: any) => {
  localStorage.setItem(key, JSON.stringify(value));
};

export const getKeyValue = (key: string) => {
  try {
    return JSON.parse(localStorage.getItem(key));
  } catch (err) {
    console.log(err);
    return null;
  }
};

export const deleteKey = (key: string) => {
  localStorage.removeItem(key);
};

export const clear = () => {
  localStorage.clear()
};


export const LANGUAGE = 'lang';
